export enum ShopperAgentAggregateInsightKind {
  Faq = "faq",
  Escalation = "escalation",
  Sentiment = "sentiment",
}
